// ENTITY fr.gestionpial.pial.dto.EcoleDetailDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { Ecole } from './Ecole';
import { AbsenceAesh } from './AbsenceAesh';
import { Classe } from './Classe';
import { AffectationAesh } from './AffectationAesh';
import { Notification } from './Notification';

export class EcoleDetailDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.EcoleDetailDTO';

  ecole: Ecole | null = null;
  classes: Classe[] | null = [];
  notifications: Notification[] | null = [];
  affectations: AffectationAesh[] | null = [];
  absencesEnCours: AbsenceAesh[] | null = [];

  constructor(init?:Partial<EcoleDetailDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.EcoleDetailDTO'] = EcoleDetailDTO;

fields['fr.gestionpial.pial.dto.EcoleDetailDTO']  = {
    ecole: 'fr.gestionpial.pial.entities.Ecole',
    classes: 'java.util.List<fr.gestionpial.pial.entities.Classe>',
    notifications: 'java.util.List<fr.gestionpial.pial.entities.Notification>',
    affectations: 'java.util.List<fr.gestionpial.pial.entities.AffectationAesh>',
    absencesEnCours: 'java.util.List<fr.gestionpial.pial.entities.AbsenceAesh>'
};
